import { dataCnyRefund } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCnyRefund = /*#__PURE__*/createIcon(dataCnyRefund)
export default IconCnyRefund
